var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrofactoriaIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 216,
    height: 216,
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-MicrofactoriaIllustration"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 216,
    height: 216
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MicrofactoriaIllustration",
    clipPath: "url(#clip-MicrofactoriaIllustration)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_50",
    "data-name": "Group 50",
    transform: "translate(-114 -58)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_49",
    "data-name": "Group 49",
    transform: "translate(-58 -61)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47",
    "data-name": "Group 47"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_35",
    "data-name": "Path 35",
    transform: "translate(172 191)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 143.5 143.5 L 0.5 143.5 L 0.5 0.5 L 143.5 0.5 L 143.5 143.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1 1 L 1 143 L 143 143 L 143 1 L 1 1 M 0 0 L 144 0 L 144 144 L 0 144 L 0 0 Z",
    stroke: "none",
    fill: "#2e3234"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M0,0,72-72V72L0,144Z",
    transform: "translate(316 191)",
    fill: "#515556",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M0,0H144L72,72H-72Z",
    transform: "translate(244 119)",
    fill: "#2e3234"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_48",
    "data-name": "Group 48",
    transform: "translate(163 178)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M75.629,66.595H63.878V28.054L43.2,64.654a5.063,5.063,0,0,1-2.153,2.121,6.071,6.071,0,0,1-2.916.722,5.98,5.98,0,0,1-2.87-.722A5.209,5.209,0,0,1,33.2,64.654l-20.767-36.6v38.54H.77V6.889a5.921,5.921,0,0,1,1.166-3.61,5.847,5.847,0,0,1,3.14-2.121,5.7,5.7,0,0,1,1.884-.135,5.2,5.2,0,0,1,1.794.406,4.87,4.87,0,0,1,1.615.948A5.177,5.177,0,0,1,11.579,3.82L38.132,50.258,64.686,3.82a5.724,5.724,0,0,1,2.825-2.437,6.11,6.11,0,0,1,3.813-.226,5.847,5.847,0,0,1,3.095,2.121,5.773,5.773,0,0,1,1.211,3.61Z",
    transform: "translate(41.23 51.045)",
    fill: "#535658"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M75.629,66.595H63.878V28.054L43.2,64.654a5.063,5.063,0,0,1-2.153,2.121,6.071,6.071,0,0,1-2.916.722,5.98,5.98,0,0,1-2.87-.722A5.209,5.209,0,0,1,33.2,64.654l-20.767-36.6v38.54H.77V6.889a5.921,5.921,0,0,1,1.166-3.61,5.847,5.847,0,0,1,3.14-2.121,5.7,5.7,0,0,1,1.884-.135,5.2,5.2,0,0,1,1.794.406,4.87,4.87,0,0,1,1.615.948A5.177,5.177,0,0,1,11.579,3.82L38.132,50.258,64.686,3.82a5.724,5.724,0,0,1,2.825-2.437,6.11,6.11,0,0,1,3.813-.226,5.847,5.847,0,0,1,3.095,2.121,5.773,5.773,0,0,1,1.211,3.61Z",
    transform: "translate(44.003 51.045)",
    fill: "#2e3234"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M8474,1459v144h144l72-72V1387H8546Z",
    transform: "translate(-8302 -1268)",
    fill: "none",
    stroke: "#2e3234",
    strokeLinecap: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M72.5-.5l-73,73",
    transform: "translate(257.5 58.5)",
    fill: "none",
    stroke: "#2e3234",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrofactoriaIllustration);
export default __webpack_public_path__ + "static/media/MicrofactoriaIllustration.7ff18330330977eb91b8fadfd7b68bb8.svg";
export { ForwardRef as ReactComponent };